const searchExpandedCardData = [
  {
    key: "military-pet-resources",
    id: 1,
    title: "Military Pet Resources & Support",
    description: "Support programs for military members with pets.",
    expandedInfo: `
  🇺🇸 **Navigating military life with pets presents unique challenges**, from deployments to frequent relocations. Fortunately, several organizations and programs provide support to service members, ensuring their pets are well cared for.
  
  ### ✔ Key Military Pet Assistance Programs:
  - **[Military OneSource](https://www.militaryonesource.mil/moving-pcs/plan-to-move/moving-with-pets/)** – Offers guidance on moving with pets, including domestic & international relocations.
  - **[Passenger & Pet Travel for PCS Moves](https://www.militaryonesource.mil/benefits/passenger-and-pet-transportation-for-pcs-moves/)** – Information on pet transport reimbursement for military families moving on orders.
  - **[Air Mobility Command Pet Travel](https://www.amc.af.mil/AMC-Travel-Site/AMC-Pet-Travel-Page/)** – Official military pet transportation guidance for service members moving with pets.
  - **[Defense Department Pet Travel Reimbursement](https://www.defense.gov/News/News-Stories/Article/Article/3684185/service-members-get-new-benefit-pet-travel-allowance/)** – Military members can receive partial reimbursement for PCS pet travel expenses.
  
  ### 📌 Additional Military Pet Travel Resources:
  - Most if not all US Airlines offer military & pet travel discounts and support for active military members. For example:
  - **[Delta Airlines Military Pet Travel](https://www.delta.com/us/en/special-circumstances/military-travel/pets)** – Discounts & pet travel support for active military members.
  - **[Army PCS Pet Expense Reimbursement](https://www.army.mil/article/272841/dod_approves_pcs_pet_expenses_reimbursement#)** – Covers PCS-related pet relocation costs for military families.
    `,
  },
  {
    key: "pet-fostering-military",
    id: 2,
    title: "Pet Fostering for Deployed Military Members",
    description: "Foster programs for military members deployed on duty.",
    expandedInfo: `
  🐕 **Deployment and emergencies can be stressful for both service members and their pets.** Luckily, there are organizations that connect military personnel with trusted foster homes to care for their pets while deployed or patients with emergency medical needs.
  
  ### ✔ Some Military Pet Fostering Organizations:
  - **[Dogs on Deployment](https://www.dogsondeployment.org/page/military-pet-owners)** – A national network of volunteers fostering pets for deployed military members.
  - **[PACT for Animals](https://pactforanimals.org/)** – Offers temporary foster homes for military personnel to ensure their pets are safe while they serve.
    `,
  },
  {
    key: "military-pet-adoption",
    id: 3,
    title: "Military Pet Adoption & Support Programs",
    description: "Adoption programs for veterans and military members.",
    expandedInfo: `
  🐶 **Veterans & active-duty military members can benefit from specialized adoption programs that pair them with loving companion pets.**
  
  ### ✔ Some Military Pet Adoption Programs - search in your area as well:
  - **[Pets for Patriots](https://www.petsforpatriots.org/)** – Matches at-risk shelter pets with veterans, creating lifelong bonds between service members and animals in need.
  - **[Pets for Vets](https://www.petsforvets.com/)** – Rescues & trains shelter dogs to become companions for veterans coping with PTSD and other service-related challenges.
  
  ### ✔ Additional Military Adoption & Support Organizations:
  - **[Northwest Battle Buddies](https://northwestbattlebuddies.org/)** – Provides service dogs for veterans.
  - **[Paws for Heroes](https://www.pawsforheroes.com/)** – A nonprofit that rescues homeless dogs and professionally trains them to serve as companion dogs for veterans suffering from PTSD, at no cost to the veteran.
  - **[Companions for Heroes](https://www.companionsforheroes.org/)** – Helps veterans and first responders adopt and care for rescue animals, providing mutual healing and companionship.
    `,
  },  
  {
    key: "financial-assistance-military",
    id: 4,
    title: "Financial Assistance for Military Pet Owners",
    description: "Financial aid for military pet owners needing support.",
    expandedInfo: `
  💰 **Caring for pets while serving in the military can be financially challenging.** Be sure to check for on-base resources as well as the following organizations that offer assistance with pet care expenses:
  
  ### ✔ Some Military Pet Financial Assistance Programs:
  - **[Operation We Are Here](https://www.operationwearehere.com/)** – A comprehensive list of financial aid programs for military and veteran pet owners.
  - **[Vets to Vets United](https://www.vetstovetsunited.org/)** – Offers support for military families needing pet-related assistance, including veterinary aid.
    `,
  },  
  {
    key: "service-dogs-military",
    id: 5,
    title: "Service Dogs for Military Veterans",
    description: "Service dog programs for veterans with PTSD and disabilities.",
    expandedInfo: `
  🐕‍🦺 **Service dogs provide life-changing support for veterans facing PTSD, mobility limitations, and other service-related conditions.**
  
  ### ✔ Some Military Service Dog Programs:
  - **[K9s for Warriors](https://k9sforwarriors.org/)** – Trains and provides service dogs to veterans coping with PTSD & other service-related injuries.
  - **[SemperK9](https://www.semperk9.org/)** – Rescues shelter dogs and trains them to be service dogs at no cost for disabled service members.
  - **[America’s VetDogs](https://www.vetdogs.org/AV/DogPrograms/getaservicedog.aspx)** – Service Dogs for Veterans, First Responders, and Active-Duty service members with disabilities.
  - **[Canine Companions](https://canine.org/service-dogs/our-dogs/veterans-initiative/)** – Service Dogs for Veterans with Post-Traumatic Stress Disorder (PTSD).
  
  📌 *These programs ensure that service members & veterans receive the necessary support for both themselves and their pets.*
    `,
  },
  {
    key: "contact-all-animal-app",
    id: 6,
    title: "Contact All Animal App Support",
    description: "Support and advertising contact information.",
    expandedInfo: `
  📬 **Need to get in touch with the All Animal App team?** Whether you're experiencing technical issues or want to advertise on the app, we’re here to help.
  
  ### ✔ Contact Us:
  
  • **Having a problem with the app?**  
  Email: [support@allanimalapp.com](mailto:support@allanimalapp.com)
  
  • **Want to advertise on the All Animal App?**  
  Email: [marketing@allanimalapp.com](mailto:marketing@allanimalapp.com)

  • **General Inquiries**  
  Email: [info@allanimalapp.com](mailto:info@allanimalapp.com)
    `,
  },  
  ];
  
  export default searchExpandedCardData;
  